// Helper Phase 3c: traduce la config "flexLayout" (ex @angular/flex-layout) in un
// oggetto stile per [ngStyle], usato dai container dinamici (form-viewer,
// data-container-viewer) dove layout/align/flex/gap arrivano a runtime dalla config.

const JUSTIFY_MAP: { [k: string]: string } = {
	start: 'flex-start', center: 'center', end: 'flex-end',
	'space-between': 'space-between', 'space-around': 'space-around', 'space-evenly': 'space-evenly',
	'flex-start': 'flex-start', 'flex-end': 'flex-end',
};
const ALIGN_MAP: { [k: string]: string } = {
	start: 'flex-start', center: 'center', end: 'flex-end',
	stretch: 'stretch', baseline: 'baseline',
	'flex-start': 'flex-start', 'flex-end': 'flex-end',
};

export function buildFxLayoutStyle(config: any): { [key: string]: string } {
	const layout: string = (config && config.flexLayout) || 'row wrap';
	const align: string = (config && config.flexLayoutAlign) || 'start';
	const flex: string = (config && config.flex) || '1 1 auto';
	const gap: string = (config && config.fxLayoutGap) || '10px';

	const layoutParts = layout.trim().split(/\s+/);
	const alignParts = align.trim().split(/\s+/);

	return {
		display: 'flex',
		'flex-direction': layoutParts[0] === 'column' ? 'column' : 'row',
		'flex-wrap': layoutParts.indexOf('wrap') >= 0 ? 'wrap' : 'nowrap',
		'justify-content': JUSTIFY_MAP[alignParts[0]] || 'flex-start',
		'align-items': alignParts[1] ? (ALIGN_MAP[alignParts[1]] || 'stretch') : 'stretch',
		'flex': flex,
		'gap': gap,
	};
}
